import Entity from 'utilities/Entity';

class Category extends Entity {}

export default new Category();
